// import React, { useState } from 'react';
// import './FilterSidebar.css';

// const FilterSidebar = () => {
//   const [openFilter, setOpenFilter] = useState('sort');

//   const handleFilterToggle = (filterName) => {
//     if (openFilter === filterName) {
//       setOpenFilter(null);
//     } else {
//       setOpenFilter(filterName);
//     }
//   };

//   return (
//     <aside className="filter-sidebar">
//       <div className={`filter-section ${openFilter === 'sort' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('sort')}>
//           <h3>SORT BY</h3>
//           <span className="filter-arrow">{openFilter === 'sort' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="radio" name="sort" defaultChecked /> Featured</label>
//           <label><input type="radio" name="sort" /> Price: Low to High</label>
//           <label><input type="radio" name="sort" /> Price: High to Low</label>
//           <label><input type="radio" name="sort" /> Newest First</label>
//         </div>
//       </div>

//       <div className={`filter-section ${openFilter === 'productType' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('productType')}>
//           <h3>PRODUCT TYPE</h3>
//           <span className="filter-arrow">{openFilter === 'productType' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="checkbox" /> T-Shirts</label>
//           <label><input type="checkbox" /> Hoodies</label>
//           <label><input type="checkbox" /> Sweatshirts</label>
//           <label><input type="checkbox" /> Shorts</label>
//         </div>
//       </div>

//       <div className={`filter-section ${openFilter === 'gender' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('gender')}>
//           <h3>GENDER</h3>
//           <span className="filter-arrow">{openFilter === 'gender' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="checkbox" defaultChecked /> Men</label>
//           <label><input type="checkbox" /> Women</label>
//           <label><input type="checkbox" /> Unisex</label>
//         </div>
//       </div>

//       <div className={`filter-section ${openFilter === 'discount' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('discount')}>
//           <h3>DISCOUNT</h3>
//           <span className="filter-arrow">{openFilter === 'discount' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="checkbox" /> 10% Off</label>
//           <label><input type="checkbox" /> 20% Off</label>
//           <label><input type="checkbox" /> 30% Off</label>
//           <label><input type="checkbox" /> 50% Off</label>
//         </div>
//       </div>

//       <div className={`filter-section ${openFilter === 'colour' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('colour')}>
//           <h3>COLOUR</h3>
//           <span className="filter-arrow">{openFilter === 'colour' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="checkbox" /> Black</label>
//           <label><input type="checkbox" /> White</label>
//           <label><input type="checkbox" /> Grey</label>
//           <label><input type="checkbox" /> Brown</label>
//           <label><input type="checkbox" /> Green</label>
//         </div>
//       </div>

//       <div className={`filter-section ${openFilter === 'size' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('size')}>
//           <h3>SIZE</h3>
//           <span className="filter-arrow">{openFilter === 'size' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="checkbox" /> XS</label>
//           <label><input type="checkbox" /> S</label>
//           <label><input type="checkbox" /> M</label>
//           <label><input type="checkbox" /> L</label>
//           <label><input type="checkbox" /> XL</label>
//           <label><input type="checkbox" /> XXL</label>
//         </div>
//       </div>

//       <div className={`filter-section ${openFilter === 'style' ? 'open' : ''}`}>
//         <div className="filter-header" onClick={() => handleFilterToggle('style')}>
//           <h3>STYLE</h3>
//           <span className="filter-arrow">{openFilter === 'style' ? '▲' : '▼'}</span>
//         </div>
//         <div className="filter-options">
//           <label><input type="checkbox" /> Oversized</label>
//           <label><input type="checkbox" /> Regular Fit</label>
//           <label><input type="checkbox" /> Slim Fit</label>
//           <label><input type="checkbox" /> Graphic</label>
//           <label><input type="checkbox" /> Plain</label>
//         </div>
//       </div>
//     </aside>
//   );
// };

// export default FilterSidebar; 


import React, { useState } from 'react';
import './FilterSidebar.css';

const FilterSidebar = ({ filters, selectedFilters, onFilterChange }) => {
  const [openFilter, setOpenFilter] = useState('sort');

  const handleFilterToggle = (filterName) => {
    setOpenFilter(openFilter === filterName ? null : filterName);
  };

  const handleChange = (filterType, value) => {
    // For single choice (sort), overwrite
    if (filterType === "sort") {
      onFilterChange({ ...selectedFilters, sort: value });
      return;
    }

    // For multi-choice (colors, sizes, productTypes)
    const current = selectedFilters[filterType] || [];
    let updated;
    if (current.includes(value)) {
      updated = current.filter(v => v !== value);
    } else {
      updated = [...current, value];
    }
    console.log({ ...selectedFilters, [filterType]: updated});
    onFilterChange({ ...selectedFilters, [filterType]: updated });
  };

  return (
    <aside className="filter-sidebar">
      {/* SORT */}
      <div className={`filter-section ${openFilter === 'sort' ? 'open' : ''}`}>
        <div className="filter-header" onClick={() => handleFilterToggle('sort')}>
          <h3>SORT BY</h3>
          <span className="filter-arrow">{openFilter === 'sort' ? '▲' : '▼'}</span>
        </div>
        {openFilter === 'sort' && (
          <div className="filter-options">
            {filters.pricings?.map((option) => (
              <label key={option}>
                <input
                  type="radio"
                  name="sort"
                  checked={selectedFilters.sort === option}
                  onChange={() => handleChange('sort', option)}
                />
                {option}
              </label>
            ))}
            <label>
              <input
                type="radio"
                name="sort"
                checked={selectedFilters.sort === 'newest'}
                onChange={() => handleChange('sort', 'newest')}
              />
              Newest
            </label>
          </div>
        )}
      </div>

      {/* PRODUCT TYPE */}
      {filters.productTypes?.length > 0 && (
        <div className={`filter-section ${openFilter === 'productType' ? 'open' : ''}`}>
          <div className="filter-header" onClick={() => handleFilterToggle('productType')}>
            <h3>PRODUCT TYPE</h3>
            <span className="filter-arrow">{openFilter === 'productType' ? '▲' : '▼'}</span>
          </div>
          {openFilter === 'productType' && (
            <div className="filter-options">
              {filters.productTypes.map(pt => (
                <label key={pt.id}>
                  <input
                    type="checkbox"
                    checked={selectedFilters.productTypes?.includes(pt.id) || false}
                    onChange={() => handleChange('productTypes', pt.id)}
                  />
                  {pt.name}
                </label>
              ))}
            </div>
          )}
        </div>
      )}

      {/* COLORS */}
      {filters.colors?.length > 0 && (
        <div className={`filter-section ${openFilter === 'colour' ? 'open' : ''}`}>
          <div className="filter-header" onClick={() => handleFilterToggle('colour')}>
            <h3>COLOUR</h3>
            <span className="filter-arrow">{openFilter === 'colour' ? '▲' : '▼'}</span>
          </div>
          {openFilter === 'colour' && (
            <div className="filter-options">
              {filters.colors.map(color => (
                <label key={color}>
                  <input
                    type="checkbox"
                    checked={selectedFilters.colors?.includes(color) || false}
                    onChange={() => handleChange('colors', color)}
                  />
                  {color}
                </label>
              ))}
            </div>
          )}
        </div>
      )}

      {/* SIZES */}
      {filters.sizes?.length > 0 && (
        <div className={`filter-section ${openFilter === 'size' ? 'open' : ''}`}>
          <div className="filter-header" onClick={() => handleFilterToggle('size')}>
            <h3>SIZE</h3>
            <span className="filter-arrow">{openFilter === 'size' ? '▲' : '▼'}</span>
          </div>
          {openFilter === 'size' && (
            <div className="filter-options">
              {filters.sizes.map(size => (
                <label key={size}>
                  <input
                    type="checkbox"
                    checked={selectedFilters.sizes?.includes(size) || false}
                    onChange={() => handleChange('sizes', size)}
                  />
                  {size}
                </label>
              ))}
            </div>
          )}
        </div>
      )}
    </aside>
  );
};

export default FilterSidebar;
